import { render, staticRenderFns } from "./PendingProposalTable.vue?vue&type=template&id=3d8de8f0"
import script from "./PendingProposalTable.vue?vue&type=script&lang=js"
export * from "./PendingProposalTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports